<template>
  <div style="max-width:900px; margin: auto;">
      <br />
      <h2>Integration</h2>
   <hr />
   <br />

<div class="seasoncast-card">
  <h5 class="card-header">Embed Channel <span  style="font-size:0.5em;vertical-align:middle;" class="badge badge-dark">Premium Only</span></h5>
  <div style="text-align:left;" class="card-body">
<h4>Display channel live feed</h4>
<p>Insert this HTML into your website to display your channel feed.</p>
<small><pre><code  class="language-html">&lt;div class=&quot;SeasonCastEvent&quot; style=&quot;position:relative;width:100%;height:0;padding-bottom:56.25%;overflow:hidden&quot;&gt;
  &lt;iframe src=&quot;https://{{channel.id}}.mylivegame.com/embed/live&quot; width=&quot;1280&quot; height=&quot;720&quot; allowfullscreen frameborder=&quot;0&quot; style=&quot;position:absolute;width:100%;height:100%;left:0;top:0;&quot;&gt;&lt;/iframe&gt;
&lt;/div&gt;
</code></pre></small>
<div class="alert alert-light" role="alert">
  <i style="font-size:80%;">Note: Free users may use up to 50 embed video request per day for testing purposes. Premium users have unlimited request and can use in production</i>
</div>
  </div>
</div>
<br />
<div class="seasoncast-card">
  <h5 class="card-header">Public API V2<span hidden style="font-size:50%;vertical-align:middle;" class="badge badge-dark">Premium Feature</span></h5>
  <div style="text-align:left;" class="card-body">
<p>Integrate your channel into custom applications with SeasonCast V2 Public API. Contact support if you need help with implementations.</p>
<br />
<a href="https://documenter.getpostman.com/view/7815111/SztK35Gr" class="btn btn-block btn-dark">Open Documentation</a>

  </div>
</div>

</div>
</template>
<script lang="ts">
import CanvasKit from 'canvaskit-wasm';
export default {
  name: 'Develop',
  props: ['channel'],
  components: {
  
  },
  async created() {
    
    const canvas = await CanvasKit({
    locateFile: (file) => {
      return `https://unpkg.com/canvaskit-wasm@0.38.0/bin/${file}`;
    },
   });
   console.log("canvas",canvas)  },
}
</script>
